import { Component, OnInit,ViewChild } from '@angular/core';
import { BackupService} from 'app/shared/services/backup.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';
import {saveAs} from 'file-saver';


@Component({
  selector: 'ngx-backup',
  templateUrl: './backup.component.html',
  styleUrls: ['./backup.component.scss']
})
export class BackupComponent implements OnInit {

  displayedColumns: string[] = ['filename', 'date', 'createdBy','action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;
  showProcessingIndicator =false;
  showrRestoringIndicator =false;

  backupList : any[];
  

  constructor(
              private router : Router, 
              private authService: AuthService,
              private route : ActivatedRoute,
              private backupService: BackupService,
              private toastr: ToastrService,
              private dialogService: DialogService,
              private themeService: NbThemeService,
              ) { 


              }

  ngOnInit() {

    this.getAllBackupList();

      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
          });
		  
  }


  getAllBackupList(){
    this.backupService.getAll()
     .subscribe(
        (data) => {
                  this.backupList = data;
                  this.dataSource = new  MatTableDataSource (this.backupList);  
                  this.dataSource.paginator = this.paginator;  
                  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }

 
     createBackupBtnClick(){
       var data = {
         createdBy : this.authService.getUserLoggedIn(),     
       }
       this.showProcessingIndicator = true;
      this.backupService.createBackup(data)
        .subscribe(
          (res)=>{
            this.toastr.success('Backup created successfully','Success');
            this.getAllBackupList();
            this.showProcessingIndicator = false;
          },
          (err)=>{
            this.toastr.error('Failed to create backup','Failure');
            if(err instanceof HttpErrorResponse){                 
              if(err.status == 401){
                this.router.navigate(['/login']);
              }
            }
            console.log(err);
            this.showProcessingIndicator = false;
          }
        );
     }

     downloadBtnClick(filename){
      this.backupService.downloadFile(filename)
      .toPromise()
       .then(blob => {
        saveAs(blob, filename);
       })
       .catch(err => console.error("download error = ", err))
     }


     restoreBtnClick(filename){
      this.dialogService.openConfirmDialog('Are you sure you want to restore this backup file?')
      .afterClosed().subscribe(res =>{
        if(res){
          this.showrRestoringIndicator = true
          this.backupService.restoreBackup(filename)
        .subscribe(
          (res) => {
                      this.toastr.success('Backup restored successfully','Success');  
                      this.showrRestoringIndicator = false;
                      this.router.navigate(['/login']); 
                    },        
          (err) =>  {
                      this.toastr.error('Failed to restore backup file','Failure');
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                      this.showrRestoringIndicator = false;
                    }, 
            )
        }
      });            
   
     }
   

     deleteButtonClick(filename : string){
      
      this.dialogService.openConfirmDialog('Are you sure you want to delete this backup file?')
      .afterClosed().subscribe(res =>{
        if(res){
          this.backupService.deleteBackup(filename)
        .subscribe(
          (res) => {
                      this.toastr.success('Backup file deleted successfully','Success');
                      this.getAllBackupList();   
                    },        
          (err) =>  {
                      this.toastr.error('Failed to delete backup file','Failure');
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    }, 
            )
        }
      });            
   }




} //end class
